//IMPORTS
import React, { useEffect, useRef } from 'react'
import { Tooltip } from '@mui/material'
import { useDispatch } from 'react-redux'

//COMPONENTES
import AgGridTable from 'src/components/AgGridTable'
import ExternalActionsTable from 'src/components/ExternalActionsTable'

//SERVICES
import { rezonificacionServices } from 'src/services/apiRezonificacion'
import { modalCRUDService } from 'src/services/modalCRUDService'

//UTILS
import { getColorCellValid } from 'src/util/functions'

//CONSTANTS
import { GlobalConstants } from 'src/data/GlobalConstants'

//STYLES
import { Colors } from 'src/assets/colors/Colors'
import { alertQuestionService } from 'src/services/alertQuestionService'

const columnDef = [
  { headerName: 'Código Propietario', field: 'Propietario', width: 150, resizable: true, sortable: true, filter: true },
  { headerName: 'Código Agente Comercial', field: 'CodigoAC', width: 150, resizable: true, sortable: true, filter: true },
  { headerName: 'Documento', field: 'Documento', hide: true },
  { headerName: 'RazonSocial', field: 'RazonSocial', hide: true },
  { headerName: 'Negocio', field: 'Negocio', hide: true },
  { headerName: 'Direccion', field: 'Direccion', hide: true },
  { headerName: 'Barrio', field: 'Barrio', hide: true },
  { headerName: 'Ciudad', field: 'Ciudad', hide: true },
  { headerName: 'Código ERP', field: 'CodigoERP', width: 150, resizable: true, sortable: true, filter: true },
  { headerName: 'Zona', field: 'Zona', width: 100, resizable: true, sortable: true, filter: true },
  { headerName: 'Portafolio', field: 'Portafolio', hide: true },
  { headerName: 'Tipologia', field: 'Tipologia', hide: true },
  { headerName: 'Frecuencia', field: 'Frecuencia', hide: true },
  { headerName: 'DiaVisita', field: 'DiaVisita', hide: true },
  { headerName: 'OrdenVisita', field: 'OrdenVisita', hide: true },
  { headerName: 'N. Zona', field: 'NuevaZona', width: 100, resizable: true, sortable: true, filter: true },
  { headerName: 'N. Portafolio', field: 'NuevoPortafolio', width: 150, resizable: true, sortable: true, filter: true },
  { headerName: 'N. Tipologia', field: 'NuevaTipologia', width: 150, resizable: true, sortable: true, filter: true },
  { headerName: 'N. Frecuencia', field: 'nmFrecuencia', width: 150, resizable: true, sortable: true, filter: true },
  { headerName: 'N. Dia', field: 'NuevoDiaVisita', width: 100, resizable: true, sortable: true, filter: true },
  { headerName: 'N. Orden', field: 'NuevoOrdenVisita', width: 100, resizable: true, sortable: true, filter: true },
  { headerName: 'Acción', field: 'accion', width: 150, resizable: true, sortable: true, filter: true },
  { headerName: 'Comentario', field: 'msg', width: 200, resizable: true, sortable: true, filter: true },
]

const exportExcelColumns = [
  { fieldOld: "Propietario", fieldNew: "Propietario" },
  { fieldOld: "CodigoAC", fieldNew: "CodigoAC" },
  { fieldOld: 'Documento', fieldNew: 'Documento' },
  { fieldOld: 'RazonSocial', fieldNew: 'RazonSocial' },
  { fieldOld: 'Negocio', fieldNew: 'Negocio' },
  { fieldOld: 'Direccion', fieldNew: 'Direccion' },
  { fieldOld: 'Barrio', fieldNew: 'Barrio' },
  { fieldOld: 'Ciudad', fieldNew: 'Ciudad' },
  { fieldOld: "CodigoERP", fieldNew: "CodigoERP" },
  { fieldOld: "Zona", fieldNew: "Zona" },
  { fieldOld: 'Portafolio', fieldNew: 'Portafolio' },
  { fieldOld: 'Tipologia', fieldNew: 'Tipologia' },
  { fieldOld: 'Frecuencia', fieldNew: 'Frecuencia' },
  { fieldOld: 'DiaVisita', fieldNew: 'DiaVisita' },
  { fieldOld: 'OrdenVisita', fieldNew: 'OrdenVisita' },
  { fieldOld: "NuevaZona", fieldNew: "NuevaZona" },
  { fieldOld: "NuevoPortafolio", fieldNew: "NuevoPortafolio" },
  { fieldOld: "NuevaTipologia", fieldNew: "NuevaTipologia" },
  { fieldOld: "nmFrecuencia", fieldNew: "NuevaFrecuencia" },
  { fieldOld: "NuevoDiaVisita", fieldNew: "NuevoDiaVisita" },
  { fieldOld: "NuevoOrdenVisita", fieldNew: "NuevoOrdenVisita" },
  { fieldOld: "accion", fieldNew: "accion" },
  { fieldOld: "msg", fieldNew: "message" },
]

const TableExcel = ({properties}) => {
  const  { procesados, noprocesados, file } = properties
  const tableRef = useRef(null);
  const dispatch = useDispatch();

  useEffect(()=>{
    tableRef.current.api.setRowData(procesados.concat(noprocesados));
  })

  const handleSave = async () => {
    alertQuestionService.showAlert({
      title: `Guardar solicitudes`,
      question: `¿Desea guardar las solicitudes de rezonificación?`,
        message: [`Solo se guardarán los registros que fueron validados de forma exitosa.\n Total de registros:`, ``],
        datos: [procesados.length],
        actionBtnAceptar: async () => {
    try {
      const { status, msg } = await rezonificacionServices.setSolicitudesRezonificacion(procesados, file);

      if(status){
        modalCRUDService.clear();
              alertQuestionService.clear();
        dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess, message: msg }});
      }

    } catch (error) {
      dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError, message: error.toString()}});
    }
        },
        actionBtnCancelar: () => alertQuestionService.clear(),
        type: GlobalConstants.alertInfo
      })
  }

  return (
    <>
      <div className='d-flex align-items-center justify-content-between mx-2'>
        <div className='d-flex justify-content-between w-25'>
          <div>
            <strong style={{fontSize: '16px'}}>Procesados: </strong>
            <span className='ml-1' style={{fontSize: '20px', color: Colors.GREEN_TEXT, fontWeight: 'bold'}}> {procesados.length}</span>
          </div>
          <div>
            <strong style={{fontSize: '16px'}}>Errores: </strong>
            <span className='ml-1' style={{fontSize: '20px', color: 'red', fontWeight: 'bold'}}> {noprocesados.length}</span>
          </div>
        </div>
        <div>
          <ExternalActionsTable
            accionExcel={{
              tableRef,
              fileName: `${file.name.slice(0, -5)}`,
              sheetName: "Hoja1",
              structure: exportExcelColumns,
            }}
            customActions={
          <Tooltip title="Guardar" aria-label="guardar" >
            <a className="icon-container-actions d-flex"
              onClick={handleSave}
            >
                <div style={{backgroundColor: Colors.COLOR_GREEN_DARK}}/>
                <i style={{color: Colors.COLOR_GREEN_DARK}} className="far fa-save fa-2x"/>
            </a>
          </Tooltip>
            }
          />
        </div>
      </div>
      <AgGridTable
        columnDef={columnDef}
        dataList={[]}
        referencia={tableRef}
        getRowStyle={getColorCellValid}
      />
    </>
  )
}

export default TableExcel
